import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../images/logo-rr-news.png';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section footer-brand">
            <img src={logo} alt="RR News Logo" className="footer-logo" />
            <p>RR NEWS TV FASTEST UPDATE</p>
            <p style={{fontSize:'12px', opacity:0.8}}>खबर आपकी, नज़र हमारी</p>
          </div>

          <div className="footer-section">
            <h4>श्रेणियां</h4>
            <ul>
              <li><a href="/category/india">इंडिया</a></li>
              <li><a href="/category/world">विश्व</a></li>
              <li><a href="/category/sports">खेल</a></li>
              <li><a href="/category/entertainment">मनोरंजन</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>जानकारी</h4>
            <ul>
              <li><Link to="/about">हमारे बारे में</Link></li>
              <li><Link to="/contact">संपर्क करें</Link></li>
              <li><Link to="/privacy">गोपनीयता नीति</Link></li>
              <li><Link to="/terms">नियम व शर्तें</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>हमसे जुड़ें</h4>
            <div className="social-links">
              <a href="https://www.facebook.com/share/1BHgNnzseW/" className="social-icon">📘</a>
              <a href="#twitter" className="social-icon">🐦</a>
              <a href="https://www.youtube.com/@R.RNewsTvFastestUpdate" className="social-icon">▶️</a>
              <a href="https://www.instagram.com/r.r.news.tv_fastest.update_?igsh=cGE1cWo2NDhkdDM=" className="social-icon">📷</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} RR NEWS TV FASTEST UPDATE</p>
          {/* <p>Made with MERN Stack (MongoDB, Express, React, Node.js)</p> */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;


